import React from 'react';
import { Box, Typography } from '@mui/material';

const FormField = ({ label, badge, helperText, children, sx }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', ...sx }}>
    {label && (
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.35 }}>
        <Typography component="label" sx={{ fontSize: '0.73rem', fontWeight: 500, color: '#334155' }}>
          {label}
        </Typography>
        {badge && (
          <Box
            component="span"
            sx={{
              backgroundColor: '#803927',
              color: '#FFFFFF',
              fontSize: 9,
              px: '4px',
              py: '1px',
              borderRadius: '4px',
              fontWeight: 600,
              ml: 0.65,
              lineHeight: 1.2
            }}
          >
            {badge}
          </Box>
        )}
      </Box>
    )}
    {children}
    {helperText && (
      <Typography variant="caption" sx={{ color: '#64748B', fontSize: '0.66rem', mt: 0.35, lineHeight: 1.3 }}>
        {helperText}
      </Typography>
    )}
  </Box>
);

export default React.memo(FormField);
